import { Icon } from "@chakra-ui/react"

export const InfinityIcon = (props: any) => (
  <Icon xmlns="http://www.w3.org/2000/svg" width="26.947" height="18.129" viewBox="0 0 26.947 18.129" {...props}>
    <g id="Group_2052" transform="translate(0.9 0.9)">
      <ellipse id="Ellipse_3" cx="8.604" cy="8.164" rx="8.604" ry="8.164" transform="translate(0 0)" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="1.8"/>
      <ellipse id="Ellipse_3-2" cx="8.604" cy="8.164" rx="8.604" ry="8.164" transform="translate(7.939 0)" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="1.8"/>
    </g>
  </Icon>
);
